import { FC } from 'react';
import TableTab from './TableTab';

interface TableTabParams {
  tables: { tableId: string; tableUrl: string }[] | undefined;
  selectedTableId?: string;
  userId: string;
}

const TableTabs: FC<TableTabParams> = ({ tables, selectedTableId, userId }) => {
  return (
    <div className="flex w-full grow flex-row items-center lg:h-10 lg:h-15 lg:px-0">
      <div className="flex gap-2 overflow-x-auto">
        {tables?.map(({ tableId, tableUrl }) => {
          if (tableId === selectedTableId) return null;
          return <TableTab key={tableId} tableId={tableId} userId={userId} tableUrl={tableUrl} />;
        })}
      </div>
    </div>
  );
};

export default TableTabs;
